import { Component, Input, OnChanges } from '@angular/core';
import { ComponentData, TabData, TabUtil } from '@ddt-web/data-service';

@Component({
	selector: 'esg-holding-rankings',
	templateUrl: './esg-holding-rankings.component.html',
	styleUrls: ['./esg-holding-rankings.component.scss']
})
export class EsgHoldingRankingsComponent implements OnChanges {
	@Input() public data: ComponentData;
	@Input() public disclosureKey: string;
	@Input() public shouldShowNoDataComponent: boolean = true;

	public isValid: boolean = false;
	public tabs: TabData[] = [];

	public ngOnChanges(): void {
		if (this.data?.success) {
			this.tabs = [this.data.getTabById('esg.top.holdings'), this.data.getTabById('esg.bottom.holdings')];
			this.isValid = this.tabs.every(tab => TabUtil.isTabValid(tab) && !TabUtil.isEmptyTab(tab));
		} else {
			this.isValid = false;
		}
	}
}
